import React from "react";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import CentricTheme from "./themes/CentricTheme";

import Layout from "./components/Common/Layout";
import Login from "./components/Auth/Login";
import Callback from "./components/Auth/Callback";
import SignUp from "./components/Auth/SignUp";
import ProtectedRoute from "./utilities/ProtectedRoute";
import AuthRouter from "./components/Auth/AuthRouter";

const App = () => (
    <ThemeProvider theme={CentricTheme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div className="App">
                <BrowserRouter>
                    <Switch>
                        <Route path="/login" component={Login} />
                        <Route path="/callback" component={Callback} />
                        <Route path="/resetpassword" component={AuthRouter} />
                        <Route path="/signup" component={SignUp} />
                        <Route path="/health" render={() => <code>{`{version: ${(process.env.REACT_APP_VERSION)}}`}</code>} />
                        <ProtectedRoute path="/" component={Layout} />
                    </Switch>
                </BrowserRouter>
            </div>
        </LocalizationProvider>
    </ThemeProvider>
);

export default App;
